import React from "react";
import {
  SearchFilter,
  DropdownFilter,
} from "../../components/generics/Filter";

const ReportRecallFilter = (props) => {
  const colClass = props.colClass ? props.colClass : "col-12 col-sm-4";
  return (
    <div className="card-header reports-filter">
      <form className="row mb-1">
        {/* Search Filter */}
        {props.searchLabel && (
          <SearchFilter
            searchLabel={props.searchLabel}
            searchPlaceholder={props.searchPlaceholder}
            searchVal={props.searchVal}
            onSearchChange={props.onSearchChange}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Second Search Filter */}
        {props.searchLabel2 && (
          <SearchFilter
            searchLabel={props.searchLabel2}
            searchPlaceholder={props.searchPlaceholder2}
            searchVal={props.searchVal2}
            onSearchChange={props.onSearchChange2}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Third Search Filter */}
        {props.searchLabel3 && (
          <SearchFilter
            searchLabel={props.searchLabel3}
            searchPlaceholder={props.searchPlaceholder3}
            searchVal={props.searchVal3}
            onSearchChange={props.onSearchChange3}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Fourth Search Filter */}
        {props.searchLabel4 && (
          <SearchFilter
            searchLabel={props.searchLabel4}
            searchPlaceholder={props.searchPlaceholder4}
            searchVal={props.searchVal4}
            onSearchChange={props.onSearchChange4}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Third Search Filter */}
        {props.searchLabel5 && (
          <SearchFilter
            searchLabel={props.searchLabel5}
            searchPlaceholder={props.searchPlaceholder5}
            searchVal={props.searchVal5}
            onSearchChange={props.onSearchChange5}
            specialColClass={props.specialColClass}
            colClass={colClass}
          />
        )}

        {/* Dropdown Filter */}
        {props.dropdownLabel && (
          <DropdownFilter
            dropdownLabel={props.dropdownLabel}
            dropdownPlaceholder={props.dropdownPlaceholder}
            dropdownVal={props.dropdownVal}
            onDropdownChange={props.onDropdownChange}
            dropdownByElement={props.dropdownByElement}
            dropdownByElementId={props.dropdownByElementId}
            dropdownOptions={props.dropdownOptions}
            colClass={colClass}
          />
        )}
      </form>
    </div>
  );
};

export default ReportRecallFilter;
